'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ComponentWithPartials = require('UIComponents/mixins/ComponentWithPartials');

var _ComponentWithPartials2 = _interopRequireDefault(_ComponentWithPartials);

var _components = require('I18n/components');

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UILoadingButton = require('UIComponents/button/UILoadingButton');

var _UILoadingButton2 = _interopRequireDefault(_UILoadingButton);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUTTON_WIDTH = '102px';

exports.default = _react2.default.createClass({
  displayName: 'StepButtonsFooter',

  mixins: [_ComponentWithPartials2.default],

  propTypes: {
    submittingMeeting: _react.PropTypes.bool,
    goToPreviousStep: _react.PropTypes.func.isRequired,
    goToNextStep: _react.PropTypes.func,
    isLastStep: _react.PropTypes.bool,
    canProceed: _react.PropTypes.bool
  },

  getForwardButtonKey: function getForwardButtonKey() {
    return this.props.isLastStep ? 'buttons.confirm' : 'buttons.next';
  },
  getForwardButtonVisibility: function getForwardButtonVisibility() {
    return Boolean(this.props.goToNextStep) ? 'visible' : 'hidden';
  },
  getProceedFunction: function getProceedFunction() {
    var _props = this.props,
        goToNextStep = _props.goToNextStep,
        goToPreviousStep = _props.goToPreviousStep;


    return goToNextStep ? this.partial(goToNextStep, goToPreviousStep) : null;
  },
  renderBackButton: function renderBackButton() {
    return _react2.default.createElement(
      _UIButton2.default,
      {
        style: { minWidth: BUTTON_WIDTH },
        onClick: this.props.goToPreviousStep,
        use: 'secondary',
        'data-selenium-test': 'back-button'
      },
      _react2.default.createElement(_UIIcon2.default, { name: icons.LEFT_ANGLE }),
      _react2.default.createElement(_components.FormattedMessage, { message: 'buttons.back' })
    );
  },
  renderForwardButton: function renderForwardButton() {
    var _props2 = this.props,
        submittingMeeting = _props2.submittingMeeting,
        canProceed = _props2.canProceed;


    var visibility = this.getForwardButtonVisibility();
    var messageKey = this.getForwardButtonKey();
    var goToNextStep = this.getProceedFunction();

    return _react2.default.createElement(
      _UILoadingButton2.default,
      {
        style: { minWidth: BUTTON_WIDTH, visibility: visibility },
        loading: submittingMeeting || false,
        onClick: goToNextStep,
        use: 'primary',
        disabled: !canProceed,
        'data-selenium-test': 'forward-button'
      },
      _react2.default.createElement(_components.FormattedMessage, { message: messageKey })
    );
  },
  render: function render() {
    return _react2.default.createElement(
      _UIFlex2.default,
      { className: 'width-100', align: 'end', justify: 'between' },
      this.renderBackButton(),
      this.renderForwardButton()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/page/StepButtonsFooter.js
// module id = 145
// module chunks = 0